import type { Cart } from '../../../../codegen/types';
import type { ExtendedLineItem } from '../../../../types/product';
import { getAmount } from '../../../currencyHelper';
import { createLineItem } from '../../utils/createLineItem';
import { sendDataLayerEvent } from '../../utils/dataLayerInteractions';
import EventNamesType from '../eventNamesType';

export const sendRemoveFromCartFromProductLineItemEvent = (
  prevCart: Cart | Record<string, never>,
  removedProductId: string,
  userCart: Cart,
  baseUrl: string,
) => {
  const cartLineItem = prevCart.lineItems?.find((item) => item.id === removedProductId);

  if (!cartLineItem || !userCart) return;

  const removedProduct: ExtendedLineItem = {
    ...cartLineItem,
    index: 0,
    images: cartLineItem.imageURLs,
    baseUrl,
  };

  const { price } = cartLineItem;
  const { value } = price;

  const cartItems = {
    items: userCart.lineItems?.map((item) => createLineItem(item)),
  };

  sendDataLayerEvent(
    EventNamesType.remove_from_cart,
    {
      ecommerce: {
        currency: value.currencyCode,
        value: +getAmount(value.centAmount) * cartLineItem.quantity,
        items: [createLineItem(removedProduct)],
      },
      cart: {
        currency: userCart.currency,
        value: +getAmount(userCart.total),
        cartItems,
      },
    },
    true,
    { cartId: userCart.id },
  );
};
